<template><div><h1>移除移动端页面点击延迟</h1>
<div class="tip">
<p>直接使用 <code>WeUI</code> 样式并引入 <code>fastclick</code> 会导致一些点击问题，VUX 组件内部已经做了相关处理。</p>
</div>
<h2>引入 fastclick</h2>
<p>在<code>main.js</code>里引用<code>fastclick</code></p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> FastClick = <span class="hljs-built_in">require</span>(<span class="hljs-string">'fastclick'</span>)
FastClick.attach(<span class="hljs-built_in">document</span>.body)
<span class="hljs-comment">// done</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue 应用移除移动端页面点击延迟 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// remove-click-delay-fastclick-432.vue?47061ad5